export default __webpack_public_path__ + "static/media/About_csi.91aed7bc.svg";